<template>
  <div
    v-loading="loading"
    class="app-main-content"
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <div class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="920"
          @click-more="value=>{isAdvancedQuery=value}"
          @simSearchItemCallBack="toAdvancedQuery()"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations" style="display: flex;">
            <el-select
              v-model="timeRange"
              filterable
              style="width: 100px;margin-left: 5px;"
              @change="onTimeRangeChange"
            >
              <el-option
                v-for="(item,index) in TIME_RANGES"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
            <el-date-picker
              v-model="commonFilter.start"
              :disabled="timeRange!==CUSTOM.code"
              type="date"
              value-format="yyyy-MM-dd"
              :editable="false"
              :clearable="false"
              style="width: 120px;margin:0 5px;"
            />-
            <el-date-picker
              v-model="commonFilter.end"
              :disabled="timeRange!==CUSTOM.code"
              type="date"
              value-format="yyyy-MM-dd"
              :editable="false"
              :clearable="false"
              style="width: 120px;margin-left: 5px;"
            />
            <span style="padding-left: 10px;">{{ $t('SeaExport.PortOfLoading') }}</span>
            <cargo-advance-select
              :select-type="TYPE_NAMES.basic_data_Seaport"
              filterable
              :default-multiple-value="commonFilter.pol"
              style="width: 150px;margin: 0 5px;"
              placeholder=""
              @parentCallBack="p=>{commonFilter.pol=p.value}"
            />
            <span style="padding-left: 10px;">{{ $t('SeaExport.PortOfDestination') }}</span>
            <cargo-advance-select
              :select-type="TYPE_NAMES.basic_data_Seaport"
              filterable
              :default-multiple-value="commonFilter.pod"
              style="width: 150px;margin: 0 5px;"
              placeholder=""
              @parentCallBack="p=>{commonFilter.pol=p.value}"
            />
            <el-checkbox
              v-model="autoRefresh"
              style="margin: 0 5px 0 15px;"
              @change="resetTimer"
            >{{ $t('SeaExport.AutomaticallyRefresh') }}</el-checkbox>
          </div>
        </search-item>
        <div class="section grid-wrapper" style="min-height: 350px;">
          <cargo-ag-grid
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :check-main-record="false"
            :deselect-main-record="false"
            :auto-fit-content="false"
            style="width: 100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </div>
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 订舱对话框 -->
    <booking-dialog
      :visible.sync="bookingDialog.visible"
      :flight="bookingDialog.flight"
      :jobs="bookingDialog.jobs"
    />
    <!-- 提单查询对话框 -->
    <query-mbl-dialog :visible.sync="queryMblDialog.visible" @callback="queryMblCallback" />
    <!-- 申请调配对话框 -->
    <mix-flight-dialog
      :visible.sync="mixFlightDialog.visible"
      :jobs="mixFlightDialog.jobs"
      @callback="toAdvancedQuery()"
    />
    <!-- 装板说明对话框 -->
    <loading-note-dialog
      :visible.sync="loadingNoteDialog.visible"
      :jobs="loadingNoteDialog.jobs"
      @callback="gridApi.setRowData(rowData)"
    />
    <!-- 收货(外仓)对话框 -->
    <warehouse-entry-dialog
      :visible.sync="warehouseEntryDialog.visible"
      :job="warehouseEntryDialog.job"
      @callback="toAdvancedQuery()"
    />
    <!-- 完成订舱对话框 -->
    <booking-done-dialog
      :visible.sync="bookingDoneDialog.visible"
      :flight="bookingDoneDialog.flight"
    />
    <!-- 报关对话框 -->
    <declare-customs-dialog
      :visible.sync="declareCustomsDialog.visible"
      :job="declareCustomsDialog.job"
    />
    <!-- 操作说明对话框 -->
    <operator-remark-dialog
      :visible.sync="operatorRemarkDialog.visible"
      :operator-id="operatorRemarkDialog.operatorId"
      :job="operatorRemarkDialog.job"
      @callback="gridApi.setRowData(rowData)"
    />
    <!-- 更新航班对话框 -->
    <update-flight-dialog
      :visible.sync="updateFlightDialog.visible"
      :operation="updateFlightDialog.operation"
      :flight="updateFlightDialog.flight"
      @callback="gridApi.setRowData(rowData)"
    />
    <!-- 交货代理对话框 -->
    <deliver-agent-dialog
      :visible.sync="deliverAgentDialog.visible"
      :jobs="deliverAgentDialog.jobs"
    />
    <!-- 上传打板照片对话框 -->
    <upload-loading-pic-dialog
      :visible.sync="uploadLoadingPicDialog.visible"
      :job="uploadLoadingPicDialog.job"
    />
    <!-- 分标签对话框 -->
    <warehouse-label-dialog
      :visible.sync="warehouseLabelDialog.visible"
      :job="warehouseLabelDialog.job"
      :warehouse-in="warehouseLabelDialog.warehouseIn"
      @callback="onWarehouseLabelChange"
    />
    <!-- 预制主单/分单对话框 -->
    <billingDialog
      :visible.sync="billingDialog.visible"
      :job="billingDialog.job"
      :doc-type="billingDialog.docType"
      @callback="delayUpdateButtonState"
    />
  </div>
</template>

<script>
import fmRouteCenterJS from './fmRouteCenter.js'
import moment from 'moment'
import jobDetailIcon from '@/assets/job-detail.png'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import bookingDialog from './components/routeCentral/aeBookingDialog'
import queryMblDialog from './components/routeCentral/queryMblDialog'
import mixFlightDialog from './components/routeCentral/mixFlightDialog'
import loadingNoteDialog from './components/routeCentral/loadingNoteDialog'
import warehouseEntryDialog from './components/routeCentral/warehouseEntryDialog'
import bookingDoneDialog from './components/routeCentral/bookingDoneDialog'
import declareCustomsDialog from './components/routeCentral/declareCustomsDialog'
import operatorRemarkDialog from './components/routeCentral/operatorRemarkDialog'
import updateFlightDialog from './components/routeCentral/updateFlightDialog'
import deliverAgentDialog from './components/routeCentral/deliverAgentDialog'
import uploadLoadingPicDialog from './components/routeCentral/uploadLoadingPicDialog'
import warehouseLabelDialog from './components/routeCentral/warehouseLabelDialog'
import billingDialog from './components/routeCentral/billingDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage } from '@/utils/commonUtil'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { TIME_RANGES, TODAY, CUSTOM } from '@/class/cargo/model/parameters/RouteConstants'

export default {
  name: 'FmRouteCentral',
  components: {
    searchItem, cargoAdvanceSelect, cargoTemplateSelectorDialog, bookingDialog, queryMblDialog, mixFlightDialog, loadingNoteDialog,
    warehouseEntryDialog, bookingDoneDialog, declareCustomsDialog, operatorRemarkDialog, updateFlightDialog, deliverAgentDialog,
    uploadLoadingPicDialog, warehouseLabelDialog, billingDialog
  },
  data() {
    const autoRefresh = LocalStorageUtils.getConfiguration('ROUTE_CENTRAL_AUTO_REFRESH') || false
    /* 更多操作按钮显示状态 */
    const moreOperatorVisible = {
      operator: {
        btDeclareCustoms: this.$checkPermission(['button_AERouteCentral_DeclareCustoms']),
        btSiteRemark: this.$checkPermission(['button_AERouteCentral_btSiteRemark']),
        btOtherCharges: this.$checkPermission(['button_AERouteCentral_btOtherCharges']),
        btDelivery: this.$checkPermission(['button_AERouteCentral_Delivery']),
        btDeliveryAgent: this.$checkPermission(['button_AERouteCentral_DeliveryAgent']),
        btUploadLoadingPic: this.$checkPermission(['button_AERouteCentral_UploadLoadingPic']),
        btLabel: this.$checkPermission(['button_AERouteCentral_Label'])
      },
      operatorVisible: false,
      bill: {
        btBillingMAWB: this.$checkPermission(['button_AERouteCentral_BillingMAWB']),
        btBillingHAWB: this.$checkPermission(['button_AERouteCentral_BillingHAWB']),
        btPrintMAWB: this.$checkPermission(['button_AERouteCentral_PrintMAWB']),
        btPrintHAWB: this.$checkPermission(['button_AERouteCentral_PrintHAWB'])
      },
      billVisible: false,
      track: {
        btTakeOff: this.$checkPermission(['button_AERouteCentral_TakeOff']),
        btArrival: this.$checkPermission(['button_AERouteCentral_Arrival']),
        btFlightState: this.$checkPermission(['button_AERouteCentral_LockFlight']) || this.$checkPermission(['button_AERouteCentral_UnlockFlight'])
      },
      trackVisible: false
    }
    // 现场操作
    moreOperatorVisible.operatorVisible = moreOperatorVisible.operator.btDeclareCustoms || moreOperatorVisible.operator.btSiteRemark ||
      moreOperatorVisible.operator.btOtherCharges || moreOperatorVisible.operator.btDelivery || moreOperatorVisible.operator.btDeliveryAgent ||
      moreOperatorVisible.operator.btUploadLoadingPic || moreOperatorVisible.operator.btLabel
    // 制单
    moreOperatorVisible.billVisible = moreOperatorVisible.bill.btBillingMAWB || moreOperatorVisible.bill.btBillingHAW ||
      moreOperatorVisible.bill.btPrintMAWB || moreOperatorVisible.bill.btPrintHAWB
    // 跟踪
    moreOperatorVisible.trackVisible = moreOperatorVisible.track.btTakeOff || moreOperatorVisible.track.btArrival ||
      moreOperatorVisible.track.btFlightState
    return {
      loading: false,
      isAdvancedQuery: false, // 是否为高级查询
      timeRange: TODAY.code,
      commonFilter: {
        start: '', // flight.ETD
        end: '', // flight.ETD
        regions: [], // port.REGION
        pod: '',
        pol: ''
      },
      oldMblNo: '',
      mblNo: '',
      autoRefresh,
      showAll: false, // true：显示所有，false：过滤掉无业务航班
      originRowData: [], // 原始行数据
      selectedNode: null,
      selectedRows: [],
      quantityActual: 0,
      weightActual: 0,
      cubageActual: 0,
      quantityContract: 0,
      weightContract: 0,
      cubageContract: 0,
      moreOperatorVisible,
      /* 更多操作按钮状态 */
      btLoadingEnabled: false,
      btFlightStateLabel: '锁定航班',
      btFlightStateEnabled: false,
      btDeliveryAgentEnabled: false,
      btBookingDoneEnabled: false,
      btPullInEnabled: false,
      btAdjustFlightEnabled: false,
      btMixFlightEnabled: false,
      btCheckBookingEnabled: false,
      btCancelCheckBookingEnabled: false,
      btTakeOffEnabled: false,
      btArrivalEnabled: false,
      btDeliveryEnabled: false,
      btDeclareCustomsEnabled: false,
      btCopyWarehouseInfoEnabled: false,
      btBookingInEnabled: false,
      btOperatorRemarksEnabled: false,
      btOtherWarehouseNotesEnabled: false,
      btOtherChargesEnabled: false,
      btSiteRemarkEnabled: false,
      btBillingMAWBEnabled: false,
      btBillingHAWBEnabled: false,
      btPrintMAWBEnabled: false,
      btPrintHAWBEnabled: false,
      btUploadLoadingPicEnabled: false,
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      bookingDialog: {
        visible: false,
        flight: {},
        jobs: []
      },
      queryMblDialog: {
        visible: false
      },
      mixFlightDialog: {
        visible: false,
        jobs: []
      },
      loadingNoteDialog: {
        visible: false,
        jobs: []
      },
      warehouseEntryDialog: {
        visible: false,
        job: {}
      },
      bookingDoneDialog: {
        visible: false,
        flight: {}
      },
      declareCustomsDialog: {
        visible: false,
        job: {}
      },
      operatorRemarkDialog: {
        visible: false,
        operatorId: '',
        job: {}
      },
      updateFlightDialog: {
        visible: false,
        operation: 0,
        flight: {}
      },
      deliverAgentDialog: {
        visible: false,
        jobs: []
      },
      uploadLoadingPicDialog: {
        visible: false,
        job: {}
      },
      warehouseLabelDialog: {
        visible: false,
        job: {},
        warehouseIn: {}
      },
      billingDialog: {
        visible: false,
        job: {},
        docType: ''
      }
    }
  },
  computed: {
    rowData() {
      if (this.showAll) {
        return this.originRowData
      }
      const validKeySet = new Set()
      for (const item of this.originRowData) {
        if (item.dataType === 4 || item.dataType === 5) {
          const keys = item.path.split(',')
          validKeySet.add(keys[0])
          validKeySet.add(keys[0] + ',' + keys[1])
          validKeySet.add(keys[0] + ',' + keys[1] + ',' + keys[2])
        }
      }
      const data = this.originRowData.filter(p => {
        if (p.dataType === 1 || p.dataType === 2 || p.dataType === 3) {
          return validKeySet.has(p.path)
        } else {
          return true
        }
      })
      return data || []
    },
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    },
    validFlight() {
      return this.selectedRow && this.selectedRow.dataType === 2 && this.selectedRow.uuid && this.selectedRow.children.length > 0
    },
    bookingEnable() {
      if (!this.selectedRow || this.selectedRow.dataType !== 2 || !this.selectedRow.uuid) {
        return false
      }
      const etd = this.selectedRow.path.split(',')[0]
      const now = moment().format('YYYY-MM-DD')
      return etd >= now
    },
    curDataType() {
      return this.selectedRow ? this.selectedRow.dataType : 0
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    selectedRow(newVal, oldVal) {
      this.delayUpdateButtonState()
    },
    selectedRows(newVal, oldVal) {
      this.delayUpdateButtonState()
    }
  },
  created() {
    // 扩展data
    Object.assign(this, {
      TYPE_NAMES,
      TIME_RANGES,
      CUSTOM,
      advanceQueryConditions: [], // 高级查询条件
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 0,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.VesselAndVoyage'),
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              const dataType = params.data.dataType
              return dataType === 2 || dataType === 3 || dataType === 4
            },
            innerRenderer: params => {
              const data = params.data
              if (data.dataType === 1) {
                return params.value
              } else if (data.dataType === 2) {
                if (data.flightNo) {
                  const etd = data.path.split(',')[0]
                  let text = data.flightNo
                  text += ' ('
                  text += moment(etd).format('MM/DD')
                  if (data.departureTime) {
                    text += ' ' + data.departureTime
                  }
                  text += ')'
                  if (data.settleState === 1) {
                    text += this.$t('Message.Locked')
                  } else if (data.settleState === 2) {
                    text += this.$t('CargoMsg.Cargo_Approved')
                  }
                  if (data.atd) {
                    text += '  ' + this.$t('queryJob.takeOff2') + ' ('
                    text += moment(data.atd).format('MM/DD HH:mm')
                    text += ')'
                  }
                  if (data.ata) {
                    text += '  ' + this.$t('queryJob.arrivedAtPort') + '('
                    text += moment(data.ata).format('MM/DD HH:mm')
                    text += ')'
                  }
                  return text
                } else {
                  return data.departureTime
                }
              } else if (data.dataType === 3 || data.dataType === 4) {
                const toLookMethod = this.documentManage.getPath('toLook')
                const showBusinessInfoMethod = this.documentManage.getPath('showBusinessInfo')
                return `<a href="javascript:void(0)"  style="border-bottom: 1px solid;" onclick="${toLookMethod}(event)">${data.jobNo}</a>
                  <img src="${jobDetailIcon}" height="16" width="16" style="vertical-align: sub;margin-left:3px;cursor:pointer" onclick="${showBusinessInfoMethod}(event)"/>`
              } else if (data.dataType === 5) {
                return data.receiptNo
              } else {
                return ''
              }
            }
          }
        },
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
          // 重置（多选）选中行
          this.selectedRows = []
          if (this.rowData.length > 0) {
            setTimeout(() => {
              let expandedNode // 需展开的node
              if (this.oldMblNo) { // 查找与提单号匹配的项，并展开
                const nodes = this.gridApi.rowModel.rootNode.allLeafChildren
                const expandedNode = nodes.find(p => p.data.dataType === 4 && p.data.mbl === this.oldMblNo)
                if (expandedNode) {
                  expandedNode.parent.expanded = true
                  expandedNode.parent.parent.expanded = true
                  if (expandedNode.data.lclMasterUuid) {
                    expandedNode.parent.parent.parent.expanded = true
                  }
                }
              }
              if (!expandedNode) { // 默认展开第一项
                expandedNode = this.gridApi.rowModel.rowsToDisplay[0]
                while (expandedNode) {
                  expandedNode.expanded = true
                  expandedNode = expandedNode.childrenAfterFilter[0]
                }
              }
              this.gridApi.onGroupExpandedOrCollapsed()
            }, 100)
          }
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        // 多选（勾选框触发）
        onRowSelected: event => {
          if (event.data.dataType === 2 || event.data.dataType === 3 || event.data.dataType === 4) { // 有效选中
            this.selectedRows = this.gridApi.getSelectedRows().filter(p => p.dataType === 2 || p.dataType === 3 || p.dataType === 4)
          } else {
            event.node.setSelected(false) // 取消无效选中
          }
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: this.getColumnDefs(),
      gridApi: null,
      updateBtnStateSeq: 1, // 执行更新按钮状态操作的次序
      documentManage: new DocumentManage(),
      timerId: 0 // 定时器ID
    })
    this.onTimeRangeChange()
    this.toAdvancedQuery()
  },
  beforeMount() {
    const self = this
    this.documentManage.set('toLook', function(e) {
      self.toLook(e)
    })
    this.documentManage.set('showBusinessInfo', function(e) {
      self.showBusinessInfo(e)
    })
    this.documentManage.set('loadingBoard', function(e) {
      self.loadingBoard(e)
    })
  },
  mounted() {
    this.$refs.searchItem.keyWords = 'keyWords' // 该输入框用不到，但必须有值，否则简单查询无法验证通过
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: fmRouteCenterJS.methods
}
</script>

<style scoped lang="scss">
#app .app-main-content .grid-view .main-content ::v-deep {
  .cargo-advance-search-quick {
    .el-input {
      display: none;
    }
  }
  .el-submenu__title {
    border-bottom-width: 0;
  }
  .grid-wrapper {
    .ag-header-group-cell-no-group::after {
      border-right: none;
    }
    .ag-header-group-cell-label {
      justify-content: center;
    }
    .ag-theme-balham {
      .ag-group-value {
        a {
          color: blue;
        }
      }
    }
  }
}
</style>
